import _ from "lodash";
import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Label, Icon } from "semantic-ui-react";
import { FilterContainer } from "./FilterContainer";

import "./DateRangeFilter.scss";

const DateRangeFilterCustomInput = ({ value, onClick, placeholder, onClear }: any) => (
  <Label className='date-picker-input' onClick={onClick}>
    {value || placeholder}
    {value && <Icon name='delete' onClick={onClear} />}
  </Label>
);

/**
 *
 * @deprecated
 */
export const DateRangePicker = ({
  ariaId,
  onChange,
  value,
  portalId,
}: {
  ariaId?: string;
  onChange: any;
  value: string | any;
  portalId?: string;
}) => {
  const save = ({ start, end }: { start: Date | undefined | null; end: Date | undefined | null }) => {
    onChange(
      JSON.stringify({
        start: start ? moment(start).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ") : undefined,
        end: end ? moment(end).endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ") : undefined,
      }),
    );
  };
  const castDate = (value: any) => {
    if (typeof value === "string") {
      if (value === "") {
        return undefined;
      }
      if (_.isNumber(value)) {
        return new Date(parseInt(value));
      }
      return new Date(value);
    }
    if (typeof value === "number") {
      return new Date(value);
    }
    return value;
  };
  const parsedValue = JSON.parse(value || "{}");
  const startDate = castDate(parsedValue["start"]);
  const endDate = castDate(parsedValue["end"]);
  return (
    <div style={{ display: "inline-block" }}>
      <DatePicker
        id={ariaId}
        selected={startDate}
        maxDate={endDate}
        onChange={(date: Date | null) => save({ start: date, end: endDate })}
        customInput={<DateRangeFilterCustomInput onClear={() => save({ start: undefined, end: endDate })} />}
        placeholderText='Start'
        portalId={portalId || "root-portal"}
      />
      &nbsp;
      <Icon name='arrows alternate horizontal' size='small' />
      <DatePicker
        selected={endDate}
        minDate={startDate}
        onChange={(date: Date | null) => save({ start: startDate, end: date })}
        customInput={<DateRangeFilterCustomInput onClear={() => save({ start: startDate, end: undefined })} />}
        placeholderText='End'
        portalId={portalId || "root-portal"}
      />
    </div>
  );
};

export const DateRangeFilter = ({ name, filterKey }: { name: string; filterKey: string }) => {
  return (
    <FilterContainer
      name={name}
      filterKey={filterKey}
      render={({ onChange, value }: any) => {
        return (
          <>
            <div
              className='DateRangeFilterInput'
              style={{
                background: "white",
                borderRadius: "4px",
                padding: "6px",
                border: "1px solid rgba(34,36,38,.15)",
                marginRight: "6px",
              }}
            >
              <DateRangePicker onChange={onChange} value={value} portalId='inline-portal' />
            </div>
            <div id='inline-portal'></div>
          </>
        );
      }}
    />
  );
};
